(function () {
    'use strict';
    angular
        .module('app')
        .controller('yesNoCancelBox', yesNoCancelBox);
    yesNoCancelBox.$inject = ['$rootScope', '$scope', '$mdDialog', 'loginService'];
    function yesNoCancelBox($rootScope, scope, $mdDialog, loginService) {
        scope.loginService = loginService;

        // Initialized in yesNoCancelBoxShow.
        scope.yesNoCancelBox = $rootScope.yesNoCancelBox;

        scope.sendEvents = function (iChoice) {
            // Close the dialog.
            $mdDialog.hide();
            // Fire the POST event.
            if (scope.yesNoCancelBox.postCloseCallback != null)
                scope.yesNoCancelBox.postCloseCallback($rootScope.yesNoCancelBox.param1, $rootScope.yesNoCancelBox.param2, iChoice);
        }

        scope.onYesNoCancelBoxYes = function () {
            scope.sendEvents(0);
        }

        scope.onYesNoCancelBoxNo = function () {
            scope.sendEvents(1);
        }

        scope.onYesNoCancelBoxCancel = function () {
            scope.sendEvents(2);
        }

        function activate() { }
        activate();
    }
})();
